var render, staticRenderFns
import script from "./dynamicFormProperty.vue?vue&type=script&lang=js&"
export * from "./dynamicFormProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d255c01e",
  null
  
)

export default component.exports